import { createSlice } from "@reduxjs/toolkit";
import { PAGINATION } from "../../constant/ReportConstants";

const initialState = {
  filters: {
    locationIds: [],
    category: "Four Wheels",
    vehicleState: "All",
    search: "",
    stockNumber: "",
    vin: "",
    years: [],
    make: "",
    model: "",
    trim: "",
    exteriorColor: "",
    interiorColor: "",
    bodyStyle: "",
  },
  data: [],
  count: 0,
  pagination: {
    current: PAGINATION.DEFAULT_CURRENT_PAGE,
    pageSize: PAGINATION.DEFAULT_PAGE_SIZE,
  },
  sorting: {
    orderBy: "vin",
    orderDirection: "asc",
  },
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setInventoryFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setInventoryData: (state, action) => {
      state.data = action.payload.data;
      state.count = action.payload.count;
    },
    setInventoryPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setInventorySorting: (state, action) => {
      state.sorting = { ...state.sorting, ...action.payload };
    },
    setInventoryLoading: (state, action) => {
      state.loading = action.payload;
    },
    setInventoryError: (state, action) => {
      state.error = action.payload;
    },
    clearInventoryData: state => {
      state.data = [];
      state.count = 0;
    },
    resetInventoryFilters: state => {
      state.filters = initialState.filters;
      state.pagination = initialState.pagination;
      state.sorting = initialState.sorting;
    },
    clearInventoryFilter: (state, action) => {
      const filterKey = action.payload;
      if (Object.prototype.hasOwnProperty.call(state.filters, filterKey)) {
        if (Array.isArray(state.filters[filterKey])) {
          state.filters[filterKey] = [];
        } else {
          state.filters[filterKey] = null;
        }
      }
    },
  },
});

export const {
  setInventoryFilters,
  setInventoryData,
  setInventoryPagination,
  setInventorySorting,
  setInventoryLoading,
  setInventoryError,
  clearInventoryData,
  resetInventoryFilters,
  clearInventoryFilter,
} = inventorySlice.actions;

export const getWhishlistFilters = state => state?.inventory?.whishlistFilters;
export const getInventoryData = state => state?.inventory?.inventoryData;
export const getWhishlistData = state => state?.inventory?.whishlistData;

export default inventorySlice.reducer;
